import { render, staticRenderFns } from "./Legenda.vue?vue&type=template&id=1b4723c8&scoped=true&lang=pug&"
import script from "./Legenda.vue?vue&type=script&lang=ts&"
export * from "./Legenda.vue?vue&type=script&lang=ts&"
import style0 from "./Legenda.vue?vue&type=style&index=0&id=1b4723c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4723c8",
  null
  
)

export default component.exports